module.exports = __webpack_public_path__ + "static/media/Sheabutter.c9a0c3ca.png";